import { render, staticRenderFns } from "./UserImageGallery.vue?vue&type=template&id=6cba05a1&scoped=true"
import script from "./UserImageGallery.vue?vue&type=script&lang=ts"
export * from "./UserImageGallery.vue?vue&type=script&lang=ts"
import style0 from "./UserImageGallery.vue?vue&type=style&index=0&id=6cba05a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cba05a1",
  null
  
)

export default component.exports